import { createSelector } from 'reselect';

const selectPhases = (state: any) => state.phases;


export const selectPhasesCurrentItem = createSelector([selectPhases], (phases) => phases.current);

export const selectPhasesListItems = createSelector([selectPhases], (phases) => phases.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPhasesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPhasesQueryItems = createSelector([selectPhases], (phases) => phases.query);

export const selectPhasesCreatedItem = createSelector([selectPhases], (phases) => phases.create);

export const selectPhasesUpdatedItem = createSelector([selectPhases], (phases) => phases.update);

export const selectPhasesReadItem = createSelector([selectPhases], (phases) => phases.read);

export const selectPhasesDeletedItem = createSelector([selectPhases], (phases) => phases.delete);

export const selectPhasesSearchedItems = createSelector([selectPhases], (phases) => phases.search);

export const selectPhasesItemsCount = createSelector([selectPhases], (phases) => phases.count);

export const selectPhasesItemsFilter = createSelector([selectPhases], (phases) => phases.filter);